import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Link as RLink } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

import { useNavigate } from 'react-router-dom';
//import Dialog, { DialogProps } from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
/*
// */


import { Page,  selectPages } from './pageSlice';
import { Tags } from '../tag/Tags';
import { usePageAddTextMutation } from '../../api/page';

export default function PageViewerToolBar( {page}: {page: Page | null} ) {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
	const navigate = useNavigate();
  const pageIdLink = page ? "/" + page.metadata.id : "";
  const [open, setOpen] = React.useState(false);
	const now = new Date();
	const nowStr = "---\n[" + now.toISOString() + "]\n\n\n";
	const [textToAdd, setTextToAdd] = useState<string>(nowStr);
	const onTTAChange = (s: string) => {
		setTextToAdd(s);
	};
	const [
		pageSave,
		{ data: data, isLoading: isUpdating, isSuccess: isSuccess }
	] = usePageAddTextMutation()
	const onPost = () => {
		if (page && page.metadata.id) {
			pageSave({id: page.metadata.id, content: textToAdd}).unwrap().then(fullfilled => {
				console.log("202501310752", isSuccess, fullfilled);
				if (fullfilled && fullfilled.page) {
					setOpen(false);
					navigate("/page/view/" + fullfilled.page.metadata.id);
				}
			});
		}
	};
  /*
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

  const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
	  console.log('is this closing happening?');
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // */


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

	return (
		<Box position="fixed" sx={sx}>
			<Box sx={sxleft}>
				<Typography>Pages</Typography>
			</Box>
			<Box sx={sxright}>
				<Link component={RLink} to={"/page/edit"}>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
				>
					New
				</Button>
				</Link>
				-
				<Link component={RLink} to={"/page/edit" + pageIdLink}>
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
				>
					Edit
				</Button>
				</Link>
      <Button variant="outlined" onClick={handleClickOpen}>
        Add Note
      </Button>
			</Box>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>Subscribe</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To subscribe to this website, please enter your email address here. We
            will send updates occasionally.
          </DialogContentText>
          <TextField
            required
            margin="dense"
            id="text-to-add"
            name="text to add"
            label="Add Text"
			value={textToAdd}
			  onChange={(e) => {onTTAChange(e.target.value)}}
            fullWidth
			multiline
            variant="standard"
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={onPost}>Subscribe</Button>
        </DialogActions>
      </Dialog>
		</Box>
	)
}
